module.exports = __webpack_public_path__ + "media/images/calendario-0d8c5ca089bf416a4a70a7f7efaa0f18.png";